export default function cloneFile(file: File) {
    return new File([file.slice()], file.name, {
        type: file.type,
        lastModified: file.lastModified
    });
}
